module.exports = __webpack_public_path__ + "static/img/logo-1.adf67027.png";